import React from 'react';
import NormalTradingV1Master from './NormalTradingV1Master';

/** Isolated TEST Master — never writes live V1 Master. */
export default function NormalTradingV1TestingMaster() {
  return (
    <NormalTradingV1Master
      apiBase="/api/normal-v1-test"
      boardPath="/NormalTrading/Testing"
      pageTitle="V1 Master TEST"
      testMode
    />
  );
}
